<template>
  <div class="as-incident-list">
    <div class="as-incident-list__head">
      <div class="as-head-current">
        <div class="as-match-time">
          <SkeletonLoader width="100px" height="20px" :line="1" />
        </div>
        <div class="as-match-status">
          <SkeletonLoader width="100px" height="20px" :line="1" />
        </div>
      </div>
      <div class="as-head-scores-round">
        <div
          class="as-head-scores-round__items"
          v-for="index in 2"
          :key="index"
        >
          <div class="as-round-name">
            <SkeletonLoader width="100px" height="20px" :line="1" />
          </div>
          <div class="as-round-scores">
            <div
              class="as-round-scores__as-home"
            >
              <SkeletonLoader width="100px" height="20px" :line="1" />
            </div>
            <div
              class="as-round-scores__as-away"
            >
              <SkeletonLoader width="100px" height="20px" :line="1" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="as-incident-list__body">
      <div
        class="as-incident__item"
        v-for="index in 5"
        :key="index"
      >
        <SkeletonLoader width="100px" height="20px" :line="1" />
        <div
          :class="`as-incident_row`"
          v-for="index in 3"
          :key="index"
        >
          <div class="as__left">
            <SkeletonLoader width="100px" height="20px" :line="1" />
          </div>
          <div class="as__right">
            <SkeletonLoader width="100px" height="20px" :line="1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

interface IProps {
  isHomePage?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>
